// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  overview: getIcon('ic_overview'),
  cart: getIcon('ic_cart'),
  people: getIcon('ic_people'),
  home:getIcon('ic_home'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  store: getIcon('ic_store'),
  creditCard: getIcon('ic_credit_card'),
};

const brandNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Allgemein',
    items: [
      // STORES
      { title: 'shops', path: PATH_DASHBOARD.brand("[brandID]").stores, icon: ICONS.store },

      // USERS
      { title: 'benutzer', path: PATH_DASHBOARD.brand("[brandID]").users, icon: ICONS.people },

      // PRODUCT-TEMPLATES
      { title: 'produktvorlagen', path: PATH_DASHBOARD.brand("[brandID]").productTemplates.root, icon: ICONS.cart },

      // BRAND
      { title: 'über', path: PATH_DASHBOARD.brand("[brandID]").about, icon: ICONS.home },

      // FINANCE
      { title: 'banking', path: PATH_DASHBOARD.brand("[brandID]").banking, icon: ICONS.creditCard },
    ],
  },
];

export default brandNavConfig;
